import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { AuthenticationService } from './authentication.service';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private router: Router, private authenticationService: AuthenticationService) {}

  canActivate() {
    if (this.authenticationService.token) {
      return true;
    } else {
      this.router.navigate(['/login']);
      return false;
    }
  }
}



// WEBPACK FOOTER //
// /app/src/app/shared/auth/auth.guard.ts